(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  var buttons = document.querySelectorAll('.navigation-drawer-trigger');
  let drawerLoaded = false;
  let drawerLoading = false;

  buttons.forEach((button) => {
    button.addEventListener('click', function(e) {
      console.log(e.currentTarget);
      var dataS = e.currentTarget.dataset.navigationIndex;
      var wrappers = document.querySelectorAll('.panel-list__wrapper');

      wrappers.forEach((wrap) => {
        wrap.hidden = true
        if (wrap.dataset.listWrapper == dataS) {
        wrap.hidden = false
        }
      });
    
      if (drawerLoaded || drawerLoading) return;
      drawerLoading = true;
      fetch(`${window.Shopify.routes.root}?section_id=navigation-drawer-lazy`)
        .then(response => response.text())
        .then(html => {      
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const sectionEl = doc.getElementById('shopify-section-navigation-drawer-lazy');

          // Injecteren in je container
          document.querySelector('.navigation-drawer-lazy').innerHTML = sectionEl.innerHTML;
          drawerLoaded = true;
        })
        .finally(() => {
          drawerLoading = false;
          var wrappers = document.querySelectorAll('.panel-list__wrapper');

          wrappers.forEach((wrap) => {
            wrap.hidden = true
            if (wrap.dataset.listWrapper == dataS) {
            wrap.hidden = false
            }
          });
        });
    });
  });
  // document.querySelector('.navigation-drawer-trigger').addEventListener('click', function() {
  //   fetch(`${window.Shopify.routes.root}?section_id=navigation-drawer-lazy`)
  //     .then(response => response.text())
  //     .then(html => {      
  //       const parser = new DOMParser();
  //       const doc = parser.parseFromString(html, 'text/html');
  //       const sectionEl = doc.getElementById('shopify-section-navigation-drawer-lazy');

  //       // Injecteren in je container
  //       document.querySelector('.navigation-drawer-lazy').innerHTML = sectionEl.innerHTML;
  //     });
  // });

document.querySelector('.open-mobile-lazy-panel').addEventListener('click', function() {
  fetch(`${window.Shopify.routes.root}?section_id=navigation-drawer-lazy-mobile`)
    .then(response => response.text())
    .then(html => {      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionEl = doc.getElementById('shopify-section-navigation-drawer-lazy-mobile');
      const mobileDrawer = document.querySelector('.navigation-drawer.mobile-version');

      if (!sectionEl || !mobileDrawer) return;

      // Injecteren in je container
      mobileDrawer.innerHTML = sectionEl.innerHTML;

      if (typeof window.replaceMatchingCollectionUrlsWithSwitchFilter === 'function') {
        window.replaceMatchingCollectionUrlsWithSwitchFilter(mobileDrawer);
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundles"] && !Shopify.designMode) return;
  try {
    
  const bundleItem = document.querySelector('.bundle__item:not(.out-of-stock)');
  if (bundleItem) {
    // Alleen eerste item zonder "out-of-stock"
    bundleItem.classList.add('popular');
    const popularLabel = bundleItem.querySelector('.most_popular_label');
    popularLabel.classList.remove('hidden');
  }

  const showMoreBundles = document.querySelector('.product-bundles__show_more_btn');
  const hiddenBundles = document.querySelectorAll('.bundle__item.hidden');
  const bundlesOuter = document.querySelector('.product-bundles__outer');
  if (showMoreBundles) {
    showMoreBundles.addEventListener('click', function () {
      hiddenBundles.forEach(function (el) {
        el.classList.toggle('hidden');
      });
      bundlesOuter.classList.toggle('expanded');
      if (bundlesOuter.classList.contains('expanded')) {
        this.textContent = window.shopmonkey.showLessBundles; // Verander de tekst van de knop
      } else {
        this.textContent = window.shopmonkey.showMoreBundles; // Verander de tekst van de knop
      }
    });
  }

  const mainProductVariants = document.querySelectorAll('.bundle-main-product-card .variant-option');
  const upsellProductVariants = document.querySelectorAll('.bundle-upsell-product-card .variant-option');

  // Initialize event listeners for both main and upsell product variants
  handleVariantSelection(mainProductVariants, true);
  handleVariantSelection(upsellProductVariants, false);

  // Dropdown variant pickers (rendered when a bundle product has > 2 variants)
  const mainProductVariantSelects = document.querySelectorAll('.bundle-main-product-card .product-card__variant-select');
  const upsellProductVariantSelects = document.querySelectorAll('.bundle-upsell-product-card .product-card__variant-select');

  handleVariantSelectDropdown(mainProductVariantSelects, true);
  handleVariantSelectDropdown(upsellProductVariantSelects, false);

  const bundleButtons = document.querySelectorAll('[data-bundle-add-to-cart]');

  bundleButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      const mainVariantId = parseInt(this.getAttribute('data-main-variant'));
      const upsellVariantId = parseInt(this.getAttribute('data-upsell-variant'));

      // Debug logging
      console.log('Main Variant ID:', mainVariantId);
      console.log('Upsell Variant ID:', upsellVariantId);

      let formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
          {
            id: upsellVariantId,
            quantity: 1,
          },
        ],
      };

      // Debug logging
      console.log('Form Data:', formData);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            // Log de response voor meer details
            response.json().then((errorData) => {
              console.log('Error Response:', errorData);
            });
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          console.log('Success:', data);
          button.textContent = 'Added to cart!';

          // Methode 1: CustomEvent
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              composed: true,
            })
          );

          // OF Methode 2: Kleine timeout
          setTimeout(() => {
            document.dispatchEvent(new Event('cart:refresh'));
          }, 100);

          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          }

          // Open de cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
          }

          // Dispatch het cart:refresh event om de inhoud bij te werken
          document.dispatchEvent(new Event('cart:refresh'));

          fetch(`${window.Shopify.routes.root}cart.js`)
            .then((response) => response.json())
            .then((cartData) => {
              const cartCount = document.querySelector('cart-count');
              if (cartCount) {
                cartCount.itemCount = cartData.item_count;
              }
            });

          setTimeout(() => {
            button.textContent = 'Add to cart';
            button.classList.remove('loading');
          }, 2000);
        })
        .catch((error) => {
          console.error('Error:', error);
          button.textContent = 'Error - Try again';
          button.classList.remove('loading');
        });
    });
  });

  function handleVariantSelection(options, isMainProduct) {
    options.forEach((option) => {
      option.addEventListener('click', function () {
        const container = isMainProduct
          ? this.closest('.bundle-main-product-card')
          : this.closest('.bundle-upsell-product-card');

        // Remove active class from all options in this container
        container.querySelectorAll('.variant-option').forEach((opt) => {
          opt.classList.remove('active');
        });

        // Add active class to clicked option
        this.classList.add('active');
        updateBundleImage(container, this);

        // Get the variant ID
        const newVariantId = this.getAttribute('data-variant-id');
        const addToCartButton = container.closest('.product-bundles__tile').querySelector('[data-bundle-add-to-cart]');

        if (addToCartButton) {
          const attributeToUpdate = isMainProduct ? 'data-main-variant' : 'data-upsell-variant';
          addToCartButton.setAttribute(attributeToUpdate, newVariantId);
          console.log(`Updated ${isMainProduct ? 'main' : 'upsell'} variant ID to:`, newVariantId);
        }
      });
    });
  }

  function handleVariantSelectDropdown(selects, isMainProduct) {
    selects.forEach((select) => {
      select.addEventListener('change', function () {
        const newVariantId = this.value;
        const tile = this.closest('.product-bundles__tile');
        const addToCartButton = tile && tile.querySelector('[data-bundle-add-to-cart]');

        if (addToCartButton) {
          const attributeToUpdate = isMainProduct ? 'data-main-variant' : 'data-upsell-variant';
          addToCartButton.setAttribute(attributeToUpdate, newVariantId);
        }

        updateBundleImage(
          this.closest(isMainProduct ? '.bundle-main-product-card' : '.bundle-upsell-product-card'),
          this.options[this.selectedIndex]
        );
      });
    });
  }

  // Show the selected variant's image (its featured media, or the product image) on the card
  function updateBundleImage(card, source) {
    const image = card && card.querySelector('.product-card__image--primary');
    const src = source && source.getAttribute('data-variant-image');
    if (!image || !src) return;

    image.srcset = source.getAttribute('data-variant-image-srcset') || '';
    image.src = src;
  }

  } catch(e) { console.error(e); }
})();
})();
